module.exports = __webpack_public_path__ + "media/customizations/northspur/logo-new-73a6cf0ab8dfbbedaac362ce43a5d7a1.png";